// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step--container {
  display: flex;
  align-self: center;
}
.step--container > li {
  width: 150px;
  text-align: -moz-center;
  text-align: -webkit-center;
}

.step--item-icon {
  height: 20px;
  width: 20px;
  background-color: #F5f5f5;
  border-radius: 100px;
  position: relative;
  margin-bottom: 25px;
}
.step--item-icon::before {
  content: "";
  position: absolute;
  width: 100px;
  top: 50%;
  bottom: 50%;
  border-bottom: 2px solid #F5f5f5;
  margin-left: -125px;
}

.step--item-text {
  color: #BEBEBE;
  font-family: proxima-nova, sans-serif;
  font-weight: 600;
}

.step--item.active .step--item-icon {
  background-color: var(--primary-color-1);
}
.step--item.active .step--item-text {
  color: var(--primary-color-1);
}
.step--item.active .step--item-icon::before {
  border-color: var(--primary-color-1);
}
.step--item:first-child .step--item-icon::before {
  border-color: transparent;
}
.step--item:last-child .step--item-icon::after {
  border-color: transparent;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .step--container {
    display: flex;
    align-self: center;
  }
  .step--container > li {
    width: 100px;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .step--item-icon::before {
    width: 50px;
    margin-left: -75px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RequestStepper/requestStepper.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,kBAAA;AADJ;AAEI;EACI,YAAA;EACA,uBAAA;EACA,0BAAA;AAAR;;AAGA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AACI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;AACR;;AAGA;EACI,cAAA;EACA,qCAAA;EACA,gBAAA;AAAJ;;AAKQ;EACI,wCAAA;AAFZ;AAIQ;EACI,6BAAA;AAFZ;AAOY;EACI,oCAAA;AALhB;AAYY;EACI,yBAAA;AAVhB;AAiBY;EACI,yBAAA;AAfhB;;AC7CY;EDmER;IACI,aAAA;IACA,kBAAA;EAlBN;EAmBM;IACI,YAAA;IACA,uBAAA;IACA,0BAAA;EAjBV;EAqBM;IACI,WAAA;IACA,kBAAA;EAnBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.step--container {\n    display: flex;\n    align-self: center;\n    > li {\n        width: 150px;\n        text-align: -moz-center;\n        text-align: -webkit-center;\n    }\n}\n.step--item-icon {\n    height: 20px;\n    width: 20px;\n    background-color: #F5f5f5;\n    border-radius: 100px;\n    position: relative;\n    margin-bottom: 25px;\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 100px;\n        top: 50%;\n        bottom: 50%;\n        border-bottom: 2px solid #F5f5f5;\n        margin-left: -125px;\n    }\n}\n\n.step--item-text {\n    color: #BEBEBE;\n    font-family: proxima-nova, sans-serif;\n    font-weight: 600;\n}\n\n.step--item {\n    &.active {\n        .step--item-icon {\n            background-color: var(--primary-color-1);\n        }\n        .step--item-text {\n            color: var(--primary-color-1);\n        }\n    }\n    &.active {\n        .step--item-icon{\n            &::before {\n                border-color: var(--primary-color-1);\n            }\n        }\n    }\n\n    &:first-child {\n        .step--item-icon {\n            &::before {\n                border-color: transparent;\n            }\n        }\n    }\n\n    &:last-child {\n        .step--item-icon {\n            &::after {\n                border-color: transparent;\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .step--container {\n        display: flex;\n        align-self: center;\n        > li {\n            width: 100px;\n            text-align: -moz-center;\n            text-align: -webkit-center;\n        }\n    }\n    .step--item-icon {\n        &::before {\n            width: 50px;\n            margin-left: -75px;\n        }\n    }\n}\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
